module.exports = __webpack_public_path__ + "img/timeline-animate.5bf01e49.svg";